<main class="confirmation">
  <header>
    <img
      class="confirmation--logo"
      src="../../../../assets/logos/seat-cupra-logo-white.svg"
      alt="{{ 'altLogo' | i18next }}"
    />
  </header>
  <mat-card class="card">
    <form [formGroup]="form" class="form">
      <mat-card-header class="card--header">
        <h2 class="card--header__title">{{ 'userCreation' | i18next }}</h2>
      </mat-card-header>
      <div class="card--content">
        <p *ngIf="group !== 'EXTERNVO'">
          {{ 'emailVerificationText' | i18next }}
        </p>
        <p *ngIf="group === 'EXTERNVO'">
          {{ 'emailVerificationTextRelative' | i18next }}
        </p>
        <span
          >{{ 'emailVerificationResendCodeText' | i18next
          }}<button
            type="button"
            class="card--content__resendBtn"
            (click)="resendCode()"
          >
            {{ 'emailVerificationResendCodeBtn' | i18next | uppercase }}
          </button></span
        >
        <span *ngIf="resendCodeText">
          <p class="card--content__resendFeedback">{{ resendCodeText }}</p>
        </span>
        <mat-form-field class="card--content__input">
          <mat-label for="code">{{ 'code' | i18next }}</mat-label>
          <input
            matInput
            type="text"
            placeholder="{{ 'code' | i18next }}"
            formControlName="code"
            #autofocus
          />
        </mat-form-field>
        <span *ngIf="controlInput('code')" class="error-message">
          <p class="error-text">{{ 'emailVerificationInputErr' | i18next }}</p>
        </span>
        <app-error-with-guide class="error-message" [message]="errorMessage">
        </app-error-with-guide>
        <app-error-with-guide
          class="error-message"
          [messageLogin]="loginErrorMessage"
          [showGuideLink]="showDownloadGuideLink"
        >
        </app-error-with-guide>
      </div>
      <mat-card-actions class="btnContainer">
        <button
          type="button"
          class="btnContainer--btnCancel btn cancel"
          [routerLink]="['/register']"
        >
          {{ 'btnCancel' | i18next | uppercase }}
        </button>
        <button
          type="submit"
          class="btnContainer--btn"
          (click)="codeVerification()"
          [disabled]="!form.valid"
        >
          {{ 'btnAccept' | i18next | uppercase }}
        </button>
        <div class="text-center spinnerContainer" *ngIf="spinner">
          <div class="spinner-border spinner" role="status"></div>
        </div>
      </mat-card-actions>
    </form>
  </mat-card>
</main>
